<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :model="queryForm" ref="queryForm">
            <el-form-item label="日期" prop="date">
                <el-date-picker
                        v-model="queryForm.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        placeholder="请选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="8" v-if="$store.getters.type==1">
                    <div>
                        总收款流水
                        <div  style="display: inline-block;position: relative">
                            <el-tooltip class="item" effect="dark" content="总收款流水＝校方收款流水+公司收款流水" placement="right">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <p class="red f12"><span class="f20 plr2">{{summary.payTotalAmount || 0}}</span>元</p>
                    <p class="c6">实际{{summary.orderCount}}单</p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="tableDataUrl" :target="'finance'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>

        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="scheduleBillCode"
                    label="账单编号"
                    :show-overflow-tooltip="true"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="billTypeDesc"
                    label="账单名称"
                    :show-overflow-tooltip="true"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="checkoutCommercialName"
                    label="商户名称"
                    :show-overflow-tooltip="true"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="expectPayDate"
                    label="生成时间"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="startDate"
                    label="开始时间"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="endDate"
                    label="结束时间"
                    width="100">
            </el-table-column>
            <el-table-column prop="orderSum" label="订单数量" width="100">
            </el-table-column>
            <el-table-column prop="refundSum" label="退单数量" width="100">
            </el-table-column>
            <el-table-column prop="billAmount" label="应收款项" width="100">
            </el-table-column>
            <el-table-column prop="billStatus" label="状态" width="">
                <template slot-scope="scope">
                    <span v-if="scope.row.billStatus == 0">未打款</span>
                    <span v-else-if="scope.row.billStatus == 1">调起自动付款</span>
                    <span v-else-if="scope.row.billStatus == 2">付款成功</span>
                    <span v-else-if="scope.row.billStatus == 3">付款失败</span>
                    <span v-else-if="scope.row.billStatus == 7">已发邮件</span>
                    <span v-else-if="scope.row.billStatus == 8">无需打款</span>
                    <span v-else-if="scope.row.billStatus == 9">冻结</span>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="pageSizes"
                :page-size="queryForm.pageSize"
                layout="sizes, prev, next"
                prev-text="上一页"
                next-text="下一页">
        </el-pagination>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../components/exportExcel2.vue";
    export default {
        components: {ExportExcel},
        data() {
            let vue = this;
            return {
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1,
                    startDate: '',
                    endDate: '',
                    dateRange: [],
                    schoolId: this.$store.getters.schoolId,
                    billTypes: [22, 23, 27]
                },

                tableData: [],//表格数据
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果
                summary: {},

                //导出
                exportParams: {},
                fileName: '对账明细表',
                fieldName: ['账单编号', '账单名称', '商户名称', '生成时间', '开始时间', '结束时间', '订单数量', '退单数量', '应收款项', '状态'],
                field: ['scheduleBillCode', 'billTypeDesc', 'checkoutCommercialName', 'expectPayDate', 'startDate', 'endDate', 'orderSum', 'refundSum', 'billAmount', 'billStatus'],
                pickerOptions: {
                    disabledDate(time) {
                        let timeOptionRange = vue.timeOptionRange;
                        let secondNum = 30 * 60 * 60 * 24 * 1000;
                        if (timeOptionRange) {
                            return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
                        }
                    },
                    onPick(time) {
                        //当第一时间选中才设置禁用
                        if (time.minDate && !time.maxDate) {
                            vue.timeOptionRange = time.minDate;
                        }
                        if (time.maxDate) {
                            vue.timeOptionRange = null;
                        }
                    }
                },

                tableDataUrl: ''
            }
        },
        created(){
            //默认显示最近一周
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
            this.tableDataUrl = '/finance/admin/bill/list';
            this.fetchData();
        },
        methods: {
            //抓取列表数据
            fetchData() {
                this.getSummary();
                this.getTableData();
            },
            getParams() {
                let params = {...this.queryForm};
                params.startDate = moment(params.dateRange[0]).format('YYYY-MM-DD');
                params.endDate = moment(params.dateRange[1]).format('YYYY-MM-DD');
                delete params.dateRange;
                return params;
            },
            getSummary() {
                let params = this.getParams();
                delete params.pageSize;
                delete params.pageNo;
                this.$apiJava.post('/finance/admin/bill/summary',params,(res)=>{
                    this.summary = res.data;
                },null,'finance')
            },
            getTableData() {
                let params = this.getParams();

                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;
                this.$apiJava.post(this.tableDataUrl,params,(res)=>{
                    this.loading = false;
                    // this.total = res.data.total || 0;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'finance')
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
//                this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.getTableData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.getTableData();
            }
        }
    }
</script>
<style lang="scss"  scoped>
    .el-card{
        border: none;
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// schoolTotalBill5.vue?fcbe5614